import { ObjectUpdate } from '../../../concepts/objects';
import { resolve } from '../../Container';
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Token } from '../../packages/tokens/Token';
import { Selection } from '../Selection';
import { Physical, RelativeTo } from '../entities/Physical';
import { ContentInjector } from '../injection/ContentInjector';
import { DeqoData } from '../injection/DeqoData';
import { Effects } from '../visualization/EffectDirector';

class CloneToolBehavior extends CreatePhysicalToolBehavior2(Physical) {

    @resolve(ContentInjector) private injector: ContentInjector;

    protected createSubject(u: ObjectUpdate) {

        const subject = this.createInstance() ?? u.create(Token);
        this.resolveRoot().add(subject);
        this.session.apply(Selection, x => x.replace([subject]));
        // Animate
        if (this.mode !== 'drag') {
            this.effects.trigger(Effects.popIn, subject);
        }

        if (this.settings.deleteSource) {
            this.deleteSource(u);
        }

        return subject;
    }

    private createInstance() {

        const target = this.objects.getMaybe(this.settings.targetId, Physical);
        if (target?.alive) {
            const tuples = DeqoData.wrap([target.toTuple(RelativeTo.Model)]);
            this.injector.injectNative(tuples);
            const [subject] = this.session.get(Selection).toArray();
            return subject.removeSelf();
        }

        return null;
    }

    private deleteSource(u: ObjectUpdate) {
        const target = this.objects.getMaybe(this.settings.targetId, Physical);
        if (target?.alive) {
            u.delete(target.removeSelf(), 'cascade');
        }
    }
}

export const cloneTool = defineToolWithCommonBehaviors({
    id: 'cloneTool',
    label: 'Clone Tool',
    category: 'util',
    icon: null,
    weight: 9999,
    behaviors: [
        CloneToolBehavior,
    ]
});
